<section class="bg-(--surface-subtle)">
  <div class="mx-auto max-w-190 px-6 py-9">
    @if (loading()) {
      <p class="py-12 text-center text-[13.5px] text-(--text-muted)" aria-live="polite">{{ 'common.loading' | translate }}</p>
    } @else if (notFound()) {
      <div class="py-12 text-center">
        <p class="m-0 mb-4 text-[15px] text-(--text-body)">{{ 'pages.documentationDetail.notFound' | translate }}</p>
        <a routerLink="/documentation"
          class="inline-flex h-10 items-center rounded-sm border border-(--brand-primary) px-4 text-[13.5px] font-bold text-(--brand-primary) transition hover:bg-(--surface-primary-tint)">
          {{ 'pages.documentationDetail.backToList' | translate }}
        </a>
      </div>
    } @else if (article(); as a) {
      <a routerLink="/documentation"
        class="mb-5 inline-flex items-center gap-1 text-[13px] font-bold text-(--brand-primary) hover:underline">
        ← {{ 'pages.documentationDetail.allDocumentation' | translate }}
      </a>

      <article appScrollReveal class="box-border overflow-hidden rounded-lg border border-(--border-subtle) bg-white shadow-(--shadow-card)">
        @if (imageUrl()) {
          <img [src]="imageUrl()" alt="" class="h-56 w-full object-cover" />
        }

        <div class="p-8">
          <div class="mb-3 flex flex-wrap items-center gap-2">
            <span class="inline-flex rounded-full bg-(--surface-primary-tint) px-3 py-1 text-[12.5px] font-bold text-(--pnud-bleu)">
              @if (resourceTypeLabelKey(a.resourceType); as key) {
                {{ key | translate }}
              } @else {
                {{ resourceTypeLabelFallback(a.resourceType) }}
              }
            </span>
            @if (a.estimatedReadMinutes) {
              <span class="text-[12.5px] text-(--text-muted)">{{ a.estimatedReadMinutes }} {{ 'pages.documentation.readMinutesSuffix' | translate }}</span>
            }
          </div>
          <h1 class="m-0 text-[26px] font-extrabold leading-tight text-(--text-body)">{{ a.title }}</h1>

          <div class="my-6 h-px bg-(--border-subtle)" aria-hidden="true"></div>

          <p class="m-0 whitespace-pre-line text-[14.5px] leading-relaxed text-(--text-body)">{{ a.body }}</p>

          @if (hasUnresolvableDocument()) {
            <p class="m-0 mt-6 text-[12.5px] text-(--text-muted)">
              {{ 'pages.documentationDetail.unresolvableDocument' | translate }}
            </p>
          }
        </div>
      </article>
    }
  </div>
</section>
